<template>
  <b-container>
    <b-row>
      <h2>Formulários</h2>
      <success-fade-alert ref="alert" msg="Formulário exluido com sucesso" />
      <fade-alert-danger ref="danger" msg="Formulário não exluido" />
    </b-row>
    <b-row>
      <b-col v-if="$store.getters.isChecklistFormCreator == true" >
        <router-link :to="getUrlCreate()">
          <b-button type="submit" size="sm"> Criar formulário </b-button>
        </router-link>
      </b-col>
    </b-row>

    <b-row><own :moduleId="moduleId"> </own></b-row>
  </b-container>
</template>
<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "ModuleFormList",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    Own: () => import("@/components_rms/checklist/own/Own.vue"),
  },
  props: {
    moduleId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "",
      },
    };
  },
  methods: {
    getUrlCreate() {
      return `/module/Layout/form/Create/${this.moduleId}`;
    },
    
  },
};
</script>
